module.exports = __webpack_public_path__ + "static/image/logo-family/logo_robot.png?7fb5772f";